import { Toolbar } from "@/components/DesignSystem";
import { Filter, FilterResult } from "@/components/DesignSystem/Toolbar/interfaces";
import { useTranslation } from 'react-i18next';

export const PromotionsToolbar = ({
  onChange,
  totalItems,
} : {
  onChange: (result: FilterResult) => void,
  totalItems?: number,
}) => {
  const { t } = useTranslation();
  const filters: Filter[] = [
    {
      id: 'show-expired',
      label: t($ => $.promotions.showExpired),
      options: [
        { id: 'show-expired', label: t($ => $.promotions.showExpired) },
      ],
      selectionMethod: 'boolean',
    },
  ];

  return (
    <Toolbar
      filters={filters}
      onChange={onChange}
      testID="promotions-toolbar-generic"
      totalItems={totalItems}
      totalUnitLabel={{
        plural: t($ => $.common.units.promotions),
        singular: t($ => $.common.units.promotion),
      }}
    />
  );
};
